<template>
  <div class="mt-5 px-2">
    <article class="message is-danger" v-if="!token">
      <div class="message-body">
        You have not signed in yet. Please go back to <a href="/">home page</a> to sign in first.
      </div>
    </article>
    <div v-if="token">
      <div>
        <span class="is-pulled-right">
          <a class="button mr-2" v-if="checked" :class="{'is-link': showSelection}" @click="toggleShowSelection">
            Selected&nbsp;<strong>{{checked}}</strong>&nbsp;products
          </a>
          <a class="button mr-2" :disabled="showSelection" @click="exportThisPage">Export</a>
        </span>

        <div>
          <h1 class="title my-title">Canada Forecast</h1>&nbsp;
          <div class="select">
            <select v-model="selectedDate"  :disabled="showSelection">
              <option v-for="(o, i) in dateOptions" :key="'date-option-' +i" :value="o.value">{{o.label}}</option>
            </select>
          </div>
        </div>

        <div class="mt-3 my-overflow" v-if="!showSelection">
          <div v-if="waiting">
            <span class="icon is-medium is-size-4">
              <i class="fas fa-spinner fa-pulse"></i>
            </span>
          </div>
          <div v-else>
            <div class="columns mt-4">
              <div class="column field mb-0 pb-0">
                <p class="control has-icons-left">
                  <span class="select">
                    <select v-model="filter">
                      <option v-for="(c, i) in classOptions"  :key="'product-class-option' + i">
                        {{c}}
                      </option>
                    </select>
                  </span>
                  <span class="icon is-small is-left">
                    <i class="fas fa-filter"></i>
                  </span>
                </p>
              </div>
              <div class="column field  mb-0 pb-0">
                <p class="control has-icons-left">
                  <input class="input" type="text" placeholder="Search" v-model="search">
                  <span class="icon is-small is-left">
                    <i class="fas fa-search"></i>
                  </span>
                </p>
              </div>
            </div>

            <div class="field is-grouped">
              <p class="control">
                <input class="input" type="number" v-model.number="periodSize">
              </p>
              <p class="control">
                <span class="select">
                  <select v-model="periods">
                    <option v-for="(ps, i) in periodsOptions" :key="'pso-'+i" :value="ps.value">{{ps.label}}</option>
                  </select>
                </span>
              </p>
              <p class="control pt-2 pl-2">
                <label class="checkbox">
                  <input type="checkbox" v-model="showHidden" />
                  Show hidden
                </label>
              </p>
            </div>

            <div class="table-container">
            <table class="table is-fullwidth is-hoverable is-striped">
              <thead>
                <th>
                  <label class="checkbox">
                    <input type="checkbox" v-model="checkAll" />
                  </label>
                </th>
                <th class="is-clickable" @click="changeSortOption('idIndex')">
                  <span>Id Index</span>
                  <span class="icon" v-if="sortOption.field == 'idIndex'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                  <br/>
                  <span class="is-size-7 has-text-grey">Id</span>
                </th>
                <th class="is-clickable" @click="changeSortOption('nsName')">
                  <span>Product</span>
                  <span class="icon" v-if="sortOption.field == 'nsName'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                  <br/>
                  <span class="is-size-7 has-text-grey">Class</span>
                </th>
                <th class="is-clickable" @click="changeSortOption('saleSpeed.value')">
                  <span>Sale Speed</span>
                  <span class="icon" v-if="sortOption.field == 'saleSpeed.value'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th class="is-clickable" @click="changeSortOption('inventory.ON')">
                  <span>Inventory</span>
                  <span class="icon" v-if="sortOption.field == 'inventory.ON'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th class="is-clickable" @click="changeSortOption('daysToSell.inventory.days')">
                  <span>Days to sell inventory</span>
                  <span class="icon" v-if="sortOption.field == 'daysToSell.inventory.days'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th class="is-clickable" @click="changeSortOption('inbounds.ON')">
                  <span>Inbound</span>
                  <span class="icon" v-if="sortOption.field == 'inbounds.ON'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th class="is-clickable" @click="changeSortOption('daysToSell.inventoryInbounds.days')">
                  <span>Days to sell inventory + inbound</span>
                  <span class="icon" v-if="sortOption.field == 'daysToSell.inventoryInbounds.days'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th class="is-clickable" @click="changeSortOption('openPos.ON')">
                  <span>Open POs</span>
                  <span class="icon" v-if="sortOption.field == 'openPos.ON'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th class="is-clickable" @click="changeSortOption('shipnow')">
                  <span>Ship now</span>
                  <span class="icon" v-if="sortOption.field == 'shipnow'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th class="is-clickable" v-for="(h, j) in shipHeaders" :key="'ship-header-' + j" @click="changeSortOption(h.field)">
                  <span>{{h.name}}</span>
                  <span class="icon" v-if="sortOption.field == h.field">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                  <br/>
                  <span class="is-size-7 has-text-grey">{{h.date}}</span>
                </th>
                <th class="is-clickable" v-for="(h, j) in shipHeaders" :key="'increase-pos-header-' + j" @click="changeSortOption(h.field1)">
                  <span>{{h.name1}}</span>
                  <span class="icon" v-if="sortOption.field == h.field1">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                  <br/>
                  <span class="is-size-7 has-text-grey">{{h.date}}</span>
                </th>
              </thead>
              <tbody>
                <tr v-for="(p, i) in showingProducts" :key="'product-' + i">
                  <td>
                    <label class="checkbox">
                      <input type="checkbox" v-model="checkboxes[p.id]" />
                    </label>
                  </td>
                  <td>
                    <span>{{p.idIndex}}</span><br/>
                    <span class="is-size-7 has-text-grey">{{p.id}}</span>
                  </td>
                  <td>
                    <span>{{p.nsName}}</span><br/>
                    <span class="is-size-7 has-text-grey">{{p.className}}</span>
                  </td>
                  <td>
                    <router-link :to="'/sale-speed/canada/' + p.id">
                      <span>{{p.saleSpeed.label}}</span>
                    </router-link>
                    &nbsp;<input type="checkbox" v-model="forecastDisabled[p.id]" @change="forecastDisabledChanged(p.id)" />
                  </td>
                  <td>
                    <span>{{p.inventory.ON}}</span>
                  </td>
                  <td>
                    <span v-if="p.daysToSell.inventory.days != undefined">{{p.daysToSell.inventory.days}}</span><br/>
                    <span class="is-size-7 has-text-grey">
                      <span>{{p.daysToSell.inventory.date}}</span>
                    </span>
                  </td>
                  <td>
                    <span>{{p.inbounds.ON}}</span>
                  </td>
                  <td>
                    <span v-if="p.daysToSell.inventoryInbounds.days != undefined">{{p.daysToSell.inventoryInbounds.days}}</span><br/>
                    <span class="is-size-7 has-text-grey">
                      <span>{{p.daysToSell.inventoryInbounds.date}}</span>
                    </span>
                  </td>
                  <td>
                    <span>{{p.openPos.ON}}</span>
                  </td>
                  <td>
                    <span>{{p.shipnow}}</span>
                  </td>
                  <td v-for="(h, j) in shipHeaders" :key="'ship-value-' + i + '-' + j">
                    <div v-if="forecastDisabled[p.id]">-</div>
                    <div v-else>
                      <span v-if="p.ships[j] != undefined">{{p.ships[j]}}</span>
                    </div>
                  </td>
                  <td v-for="(h, j) in shipHeaders" :key="'increase-pos-value-' + i + '-' + j">
                    <div v-if="forecastDisabled[p.id]">-</div>
                    <div v-else>
                      <span v-if="p.increasePos[j] != undefined">{{p.increasePos[j]}}</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
          </div>
        </div>

        <div v-if="showSelection" class="mt-5">
          <table class="table is-fullwidth">
            <thead>
              <th></th>
              <th class="is-clickable" @click="changeSelectionSortOption('idIndex')">
                <span>Id Index</span>
                <span class="icon" v-if="selectionSortOption.field == 'idIndex'">
                  <i class="fas" :class="{'fa-sort-up': selectionSortOption.asc, 'fa-sort-down': !selectionSortOption.asc}"></i>
                </span>
                <br/>
                <span class="is-size-7 has-text-grey">Id</span>
              </th>
              <th class="is-clickable" @click="changeSelectionSortOption('nsName')">
                <span>Product</span>
                <span class="icon" v-if="selectionSortOption.field == 'nsName'">
                  <i class="fas" :class="{'fa-sort-up': selectionSortOption.asc, 'fa-sort-down': !selectionSortOption.asc}"></i>
                </span>
                <br/>
                <span class="is-size-7 has-text-grey">Class</span>
              </th>
              <th class="is-clickable" @click="changeSelectionSortOption('inventory.ON')">
                <span>Inventory</span>
                <span class="icon" v-if="selectionSortOption.field == 'inventory.ON'">
                  <i class="fas" :class="{'fa-sort-up': selectionSortOption.asc, 'fa-sort-down': !selectionSortOption.asc}"></i>
                </span>
                <br/>
                <span class="is-size-7 has-text-grey">ON</span>
              </th>
              <th class="is-clickable" @click="changeSelectionSortOption('inbounds.ON')">
                <span>Inbound</span>
                <span class="icon" v-if="selectionSortOption.field == 'inbounds.ON'">
                  <i class="fas" :class="{'fa-sort-up': selectionSortOption.asc, 'fa-sort-down': !selectionSortOption.asc}"></i>
                </span>
                <br/>
                <span class="is-size-7 has-text-grey">ON</span>
              </th>
              <th class="is-clickable" @click="changeSelectionSortOption('openPos.ON')">
                <span>Open POs</span>
                <span class="icon" v-if="selectionSortOption.field == 'openPos.ON'">
                  <i class="fas" :class="{'fa-sort-up': selectionSortOption.asc, 'fa-sort-down': !selectionSortOption.asc}"></i>
                </span>
                <br/>
                <span class="is-size-7 has-text-grey">ON</span>
              </th>
              <th>
                <span>{{periodSize}} days</span><br/>
                <span class="is-size-7 has-text-grey">ON</span><br/>
                <span class="is-size-7 has-text-grey">{{shipHeaders[0].date}}</span>
              </th>
              <th>
                <label class="checkbox">
                  <input type="checkbox" v-model="colEnabled.ON45" />
                  {{periodSize}}
                </label><br/>
                <span class="is-size-7 has-text-grey ml-4">ON</span>
              </th>
              <th>
                <span>{{periodSize*2}} days</span><br/>
                <span class="is-size-7 has-text-grey">ON</span><br/>
                <span class="is-size-7 has-text-grey">{{shipHeaders[1].date}}</span>
              </th>
              <th>
                <label class="checkbox">
                  <input type="checkbox" v-model="colEnabled.ON90" />
                  {{periodSize*2}}
                </label><br/>
                <span class="is-size-7 has-text-grey ml-4">ON</span>
              </th>
            </thead>
            <tbody>
              <tr v-for="(s, i) in selection" :key="'selection-' + i" v-if="s.selected">
                <td>
                  <label class="checkbox">
                    <input type="checkbox" v-model="s.enabled" />
                  </label>
                </td>
                <td>
                  <span>{{s.idIndex}}</span><br/>
                  <span class="is-size-7 has-text-grey">{{s.id}}</span>
                </td>
                <td>
                  <span>{{s.nsName}}</span><br/>
                  <span class="is-size-7 has-text-grey">{{s.className}}</span>
                </td>
                <td>
                  <span>{{s.inventory.ON}}</span>
                </td>
                <td>
                  <span>{{s.inbounds.ON}}</span>
                </td>
                <td>
                  <span>{{s.openPos.ON}}</span>
                </td>
                <td>
                  <div v-if="forecastDisabled[s.id]">-</div>
                  <div v-else>{{s.increasePos[0]}}</div>
                </td>
                <td>
                  <input class="input po-input" :class="{'disabled-po-input': !s.enabled || !colEnabled.ON45}" :disabled="!s.enabled || !colEnabled.ON45" type="number" v-model.number="s.ship45.ON" />
                </td>
                <td>
                  <div v-if="forecastDisabled[s.id]">-</div>
                  <div v-else>{{s.increasePos[1]}}</div>
                </td>
                <td>
                  <input class="input po-input" :class="{'disabled-po-input': !s.enabled || !colEnabled.ON90}" :disabled="!s.enabled || !colEnabled.ON90" type="number" v-model.number="s.ship90.ON" />
                </td>
              </tr>
              <tr>
                <td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                <td><a class="button is-link" :disabled="!poCounts.ON45" @click="openCreatePurchaseOrderModal('ON', 45)">45 ON</a></td>
                <td></td>
                <td><a class="button is-link" :disabled="!poCounts.ON90" @click="openCreatePurchaseOrderModal('ON', 90)">90 ON</a></td>
              </tr>
            </tbody>
          </table>

          <article class="message is-success" v-if="newPONums.length">
            <div class="message-header">
              <p>New Created POs</p>
            </div>
            <div class="message-body">
              <ol>
                <li v-for="(p, i) in newPONums" :key="'np-'+i">{{p}}</li>
              </ol>
            </div>
          </article>
        </div>
      </div>
      
      
      <div v-if="error" class="notification is-danger is-light">
        <button class="delete" @click="error=''"></button>
        {{error}}
      </div>
    </div>

    <create-purchase-order-modal :opened="createPurchaseOrderModal.opened" :vendors="createPurchaseOrderModal.vendors"
      :location="createPurchaseOrderModal.location" :days="createPurchaseOrderModal.days"
      :requestDate="createPurchaseOrderModal.requestDate" :items="createPurchaseOrderModal.items"
      @closeCreatePurchaseOrderModal="closeCreatePurchaseOrderModal">
    </create-purchase-order-modal>
  </div>
</template>

<script>
import dateFormat from 'dateformat'
import { saveAs } from 'file-saver'
import CreatePurchaseOrderModal from '@/components/modals/CreatePurchaseOrderModal'

function getFieldValue (obj, path, forecastDisabled) {
  if (forecastDisabled && (path.startsWith('ships') || path.startsWith('increasePos'))) {
    return '-'
  }

  var ss = path.split('.')
  var value = obj[ss[0]]
  var i = 1
  while (i < ss.length && value) {
    value = value[ss[i]]
    i += 1
  }
  return value
}

function getFieldValueText (obj, path, forecastDisabled) {
  var value = getFieldValue(obj, path, forecastDisabled)
  if (value == undefined || value == null) {
    return ''
  }
  return value.toString()
}

export default {
  name: 'ForecastCanada',
  components: {
    CreatePurchaseOrderModal,
  },
  data () {
    return {
      error: '',
      waiting: false,
      search: '',
      filter: 'All',
      products: [],
      classOptions: [],
      search: '',
      sortOption: { field: 'id', asc: true },
      periods: 5,
      periodSize: 30,
      shippingDays: {},
      selectedDate: null,
      dateOptions: [
        {label: 'Now', value: null}
      ],
      checkboxes: {},
      checkAll: false,
      showSelection: false,
      selection: [],
      selectionSortOption: { field: 'idIndex', asc: true },
      colEnabled: {ON45: true, ON90: true},
      createPurchaseOrderModal: {
        opened: false,
        vendors: [],
        location: null,
        days: null,
        requestDate: null,
        items: [],
      },
      newPONums: [],
      forecastDisabled: {},
      showHidden: false,
    }
  },
  computed: {
    server () {
      return this.$store.state.config.server
    },
    token () {
      return this.$store.state.user.token
    },
    todayDate () {
      if (this.selectedDate) {
        return new Date(this.selectedDate)
      }
      return new Date()
    },
    shipHeaders () {
      var headers = []
      var period = 1
      var now = this.todayDate
      while(period <= this.periods) {
        var days = this.periodSize * period
        var date = new Date(now.getTime() + (days * 86400000))
        headers.push({
          name: 'Ship in ' + days + ' days',
          date: dateFormat(date, 'yyyy-mm-dd'),
          field: 'ships.' + (period - 1),
          name1: 'increase POs ship-in-' + days + '-days',
          field1: 'increasePos.' + (period - 1),
        })
        period += 1
      }
      return headers
    },
    periodsOptions () {
      var periodSize = this.periodSize || 45
      return [2, 3, 4, 5, 6, 7, 8].map(ps => ({
        value: ps,
        label: 'Ship in ' + (ps * periodSize) + ' days'
      }))
    },
    showingProducts () {
      var vm = this
      var filteredProducts = this.products.filter(p => {
        if (vm.filter == 'All') {
          return true
        }
        return p.className == vm.filter
      }).filter(p => {
        var search = vm.search.toLowerCase()
        return p.id.toString().toLowerCase().includes(search)
          || p.model.toLowerCase().includes(search)
          || p.nsName.toLowerCase().includes(search)
          || p.className.toLowerCase().includes(search)
          || p.idIndex.toLowerCase().includes(search)
      }).filter(p => vm.showHidden || !vm.forecastDisabled[p.id])

      var computedProducts = filteredProducts.map(p => vm.computeProduct(p))

      var sort = vm.sortOption
      var sortedProducts = computedProducts.sort((a, b) => {
        var va = getFieldValue(a, sort.field)
        var vb = getFieldValue(b, sort.field)
        if (!va || !vb) {
          if (va) {
            return sort.asc ? 1 : -1
          }
          if (vb) {
            return sort.asc ? -1 : 1
          }
          return 0
        }
        if (sort.field == 'id' || sort.field == 'inventory.ON' || sort.field == 'saleSpeed.value'
          || sort.field == 'inbounds.ON'|| sort.field == 'openPos.ON' || sort.field.startsWith('ships.')
          || sort.field.startsWith('increasePos.') || sort.field.startsWith('daysToSell.')) {
          return sort.asc ? va - vb : vb - va
        }
        return sort.asc ? va.localeCompare(vb) : vb.localeCompare(va)
      })
      return sortedProducts
    },
    checked () {
      var checked = 0
      for (var id in this.checkboxes) {
        if (this.checkboxes[id]) {
          checked += 1
        }
      }
      return checked
    },
    poCounts () {
      var counts = {ON45: 0, ON90: 0}
      for (var s of this.selection) {
        if (this.colEnabled.ON45 && s.selected && s.enabled && s.ship45.ON) {
          counts.ON45 += s.ship45.ON
        }
        if (this.colEnabled.ON90 && s.selected && s.enabled && s.ship90.ON) {
          counts.ON90 += s.ship90.ON
        }
      }
      return counts
    },
  },
  watch: {
    selectedDate: function (val) {
      if (val) {
        this.getScreenshot(val)
      } else {
        this.getProducts()
      }
    },
    checkAll: function (val) {
      for (var p of this.showingProducts) {
        this.checkboxes[p.id] = val
      }
    },
  },
  methods: {
    toggleShowSelection () {
      this.showSelection = !this.showSelection
      if (this.showSelection) {
        this.updateSelection()
      }
    },
    updateSelection () {
      var productMap = {}
      for (var p of this.products) {
        productMap[p.id] = p
      }
      var selectionMap = {}
      for (var s of this.selection) {
        selectionMap[s.id] = s
      }

      for (var id in this.checkboxes) {
        if (this.checkboxes[id]) {
          if (selectionMap[id]) {
            selectionMap[id].selected = true
            this.updateSelectionItem(selectionMap[id], productMap[id])
          } else {
            selectionMap[id] = this.createSelectionItem(productMap[id])
          }
        } else if (selectionMap[id]) {
          selectionMap[id].selected = false
        }
      }
      this.selection = Object.values(selectionMap).sort((a, b) => {
        if (a.className == b.className) {
          return a.id - b.id
        }
        return a.className.localeCompare(b.className)
      })
      this.sortSelection()
    },
    sortSelection () {
      var selection = this.selection.slice()
      var sort = this.selectionSortOption
      var sortedSelection = selection.sort((a, b) => {
        var va = getFieldValue(a, sort.field)
        var vb = getFieldValue(b, sort.field)
        if (!va || !vb) {
          if (va) {
            return sort.asc ? 1 : -1
          }
          if (vb) {
            return sort.asc ? -1 : 1
          }
          return 0
        }
        if (sort.field == 'inventory.US' || sort.field == 'inbounds.US' || sort.field == 'openPos.US') {
          return sort.asc ? va - vb : vb - va
        }
        return sort.asc ? va.localeCompare(vb) : vb.localeCompare(va)
      })
      this.selection = sortedSelection
    },
    changeSelectionSortOption (field) {
      this.selectionSortOption = {
        field: field,
        asc: field == this.selectionSortOption.field ? !this.selectionSortOption.asc : true
      }
      this.sortSelection()
    },
    updateSelectionItem (s, p) {
      var ship45Changed = s.ship45.ON != s.increasePos[0]
      var ship90Changed = s.ship90.ON != s.increasePos[1]
      var cp = this.computeProduct(p)
      var cp = this.computeProduct(p)
      s.increasePos = cp.increasePos
      if (!ship45Changed) {
        s.ship45 = {ON: cp.increasePos[0]}
        if (this.forecastDisabled[p.id]) {
          s.ship45 = {ON: 0}
        }
      }
      if (!ship90Changed) {
        s.ship90 = {ON: cp.increasePos[1]}
        if (this.forecastDisabled[p.id]) {
          s.ship90 = {ON: 0}
        }
      }
    },
    createSelectionItem (p) {
      var cp = this.computeProduct(p)
      console.log('createSelectionItem', cp)
      var ship45 = {ON: cp.increasePos[0]}
      var ship90 = {ON: cp.increasePos[1]}
      if (this.forecastDisabled[p.id]) {
        ship45 = {ON: 0}
        ship90 = {ON: 0}
      }
      return {...cp, selected: true, enabled: true, ship45: ship45, ship90: ship90}
    },
    getProducts () {
      this.waiting = true
      this.$http.get(this.server + '/myapp/get-products-for-forecast/').then(resp => {
        this.getProductsFromResp(resp)
        this.waiting = false
      }, err => {
        this.error = err.body
        this.waiting = false
      })
    },
    getProductsFromResp (resp) {
      this.products = resp.body.products.map(p => this.makeProduct(p, resp.body.shippingDays))
      this.shippingDays = resp.body.shippingDays
      var classNames = new Set()
      this.products.forEach(p => classNames.add(p.className))
      this.classOptions = [...classNames]
      this.classOptions.sort((a, b) => a.localeCompare(b))
      this.classOptions.unshift('All')
      var checkboxes = {}
      var forecastDisabled = {}
      for (var p of this.products) {
        checkboxes[p.id] = false
        forecastDisabled[p.id] = p.forecastParams.canadaForecastDisabled
      }
      this.checkboxes = checkboxes
      this.forecastDisabled = forecastDisabled
    },
    makeProduct (p, shippingDays) {
      return {
        id: p.product.id,
        model: p.product.model,
        nsName: p.product.nsName,
        className: p.product.productClass,
        idIndex: p.product.nsIdIndex,
        inventory: this.makeInventory(p.inventory),
        saleSpeed: this.getSaleSpeed(p.product),
        inbounds: this.makeInbounds(p.inventory),
        openPos: this.makeOpenPos(p.inventory),
        forecastParams: this.getForecastParams(p.product, shippingDays),
      }
    },
    makeInventory (inventory) {
      var onInventory = inventory.onInventory || 0
      return {
        ON: onInventory,
      }
    },
    getSaleSpeed (p) {
      var salesData = p.salesData ? JSON.parse(p.salesData) : {}
      var saleSpeed = salesData.saleSpeedCanada || 0
      var saleSpeedLabel = saleSpeed ? this.roundNum(saleSpeed) : '0'
      return {value: saleSpeed, label: saleSpeedLabel}
    },
    makeInbounds (inventory) {
      var inbounds = inventory.inbounds ? JSON.parse(inventory.inbounds) : {}
      inbounds.ON = inbounds.ON ? parseInt(inbounds.ON) : 0
      return inbounds
    },
    makeOpenPos (inventory) {
      var openPos = inventory.openPos ? JSON.parse(inventory.openPos) : {}
      openPos.ON = openPos.ON ? parseInt(openPos.ON) : 0
      return openPos
    },
    getForecastParams (p, shippingDays) {
      var forecastParams = p.forecastParams ? JSON.parse(p.forecastParams) : {}
      if (!forecastParams.daysToStock) {
        forecastParams.daysToStock = 45
      }
      if (!forecastParams.factoryPrepDays) {
        forecastParams.factoryPrepDays = 45
      }
      if (shippingDays) {
        forecastParams.shippingDays = shippingDays.Canada
      }
      if (!forecastParams.shippingDays) {
        forecastParams.shippingDays = 55
      }
      return forecastParams
    },
    computeProduct (p) {
      var daysToSell = this.computeDayToSell(p)
      var computeShipsResult = this.computeShips(p)
      var ships = computeShipsResult[0]
      var shipnow = computeShipsResult[1]
      var increasePos = this.computeIncreasePos(p, ships, shipnow)
      return {...p, daysToSell: daysToSell, ships: ships, shipnow: shipnow, increasePos: increasePos}
    },
    computeDayToSell (p) {
      var daysToSell = {inventory: {}, inventoryInbounds: {}}
      var speed = p.saleSpeed.value
      if (!speed) {
        return daysToSell
      }
      var inventory = p.inventory.ON
      var inbounds = p.inbounds.ON
      var now = this.todayDate
      var daysToSellInventoryDays = Math.round(inventory / speed)
      var daysToSellInventoryDate = new Date(now.getTime() + (daysToSellInventoryDays * 86400000))
      daysToSell['inventory'] = {days: daysToSellInventoryDays, date: dateFormat(daysToSellInventoryDate, 'yyyy-mm-dd')}
      var daysToSellInventoryInboundsDays = Math.round((inventory + inbounds) / speed)
      var daysToSellInventoryInboundsDate = new Date(now.getTime() + (daysToSellInventoryInboundsDays * 86400000))
      daysToSell['inventoryInbounds'] = {days: daysToSellInventoryInboundsDays, date: dateFormat(daysToSellInventoryInboundsDate, 'yyyy-mm-dd')}
      return daysToSell
    },
    computeShips (p) {
      var ships = []
      var period = 1
      var sum = 0
      var speed = p.saleSpeed.value
      var shippingDays = p.forecastParams.shippingDays
      var daysToStock = p.forecastParams.daysToStock
      var factoryPrepDays = p.forecastParams.factoryPrepDays
      var inventory = p.inventory.ON
      var inbounds = p.inbounds.ON
      var periodSize = this.periodSize
      var maxInboundDay = 30
      var shipnow = 0

      // Adjust daysToStock based on speed
      var adjustDaysToStock = daysToStock
      if (daysToStock > 30) {
        if (speed >= 1) {
          adjustDaysToStock = daysToStock
        } else if (speed < 1) {
          adjustDaysToStock = daysToStock + Math.max((20 * speed - 20), -15)
        }
      }

      while (period <= this.periods) {
        if (period == 1) {
          //var l = (inventory + inbounds) / speed - shippingDays
          //var l1 = Math.max(l, 0)
          //var leftDay1 = Math.min(l1*2, adjustDaysToStock) - l1
          //var leftDay2 = Math.max(leftDay1 + periodSize, 0)
          //var ship1 = speed * leftDay2
          //ships.push(Math.round(ship1))
          var goalStock = Math.max(adjustDaysToStock, maxInboundDay)
          var overStockDay = Math.max((inventory + inbounds) / speed - shippingDays - adjustDaysToStock, 0)
          var leftAfterP1 = Math.max((inventory + inbounds) / speed - shippingDays, 0)
          var shipnowDay = 0
          if (overStockDay == 0) {
            shipnowDay = Math.max(goalStock - leftAfterP1, 0)
          }
          shipnow = Math.round(shipnowDay * speed)
          var leftAfterP11 = Math.max((inventory + inbounds) / speed - shippingDays, 0) + shipnowDay
          var osAfter30 = Math.max(leftAfterP11 - shippingDays - adjustDaysToStock, 0)
          var leftAfterP2 = Math.max(leftAfterP11 - shippingDays, 0)
          var shipd0 = 0
          if (osAfter30 == 0) {
            shipd0 = Math.max(goalStock - leftAfterP2, 0)
          }          
          var shipd1 = Math.min(shipd0, periodSize)
          var ship1 = shipd1 * speed
          ships.push(Math.round(ship1))
          sum += (ship1 + shipnow)
        } else {
          var v1 = inventory + inbounds + sum - (speed * periodSize * period) - speed*shippingDays
          var m1 = Math.max(v1, 0)
          var v2 = speed * (goalStock) - m1
          var m2 = Math.max(v2, 0)
          ships.push(Math.round(m2))
          sum += m2
        }
        period += 1
      }
      return [ships, shipnow]
    },
    computeIncreasePos (p, ships, shipnow) {
      var openPos = p.openPos.ON
      var sum = 0
      var increasePos = []
      for (var i = 0; i < ships.length; i++) {
        var shipCurrent = ships[i]
        var ship = (i === 0) ? (shipCurrent + shipnow) : shipCurrent
        var m1 = Math.max(openPos - sum, 0)
        var m2 = Math.max(ship - m1, 0)
        increasePos.push(Math.round(m2))
        sum += ship
      }
      return increasePos
    },
    roundNum (n) {
      if (n >= 10) {
        return Math.round(n)
      }
      if (n >= 1) {
        return Math.round(n * 10) / 10
      }
      return Math.round(n * 100) / 100
    },
    changeSortOption (field) {
      this.sortOption = {
        field: field,
        asc: field == this.sortOption.field ? !this.sortOption.asc : true
      }
    },
    exportThisPage () {
      if (this.showSelection) {
        return
      }
      var headers = ['id', 'idIndex', 'nsName', 'className', 'saleSpeed.value', 
        'inventory.ON', 'daysToSell.inventory.days', 'daysToSell.inventory.date',
        'inbounds.ON', 'daysToSell.inventoryInbounds.days', 'daysToSell.inventoryInbounds.date', 
        'openPos.ON', 'shipnow',
        'forecastParams.daysToStock', 'forecastParams.factoryPrepDays', 'forecastParams.shippingDays',
      ]
      for (var h of this.shipHeaders) {
        headers.push({label: h.name + ': ' + h.date, value: h.field})
      }
      for (var i=0;i<this.shipHeaders.length;i++) {
        var h = this.shipHeaders[i]
        headers.push({label: h.name1 + ': ' + h.date, value: h.field1})
      }
      var rows = this.showingProducts.map(p => headers.map (h => 
        (h.value ? 
          getFieldValueText(p, h.value, this.forecastDisabled[p.id])
          :
          getFieldValueText(p, h, this.forecastDisabled[p.id])
        )
      ).join('\t'))
      rows.unshift(headers.map(h => h.label ? h.label : h).join('\t'))
      var string = rows.join('\r\n')
      var blob = new Blob([string], {type: 'text/plain;charset=utf-8'})
      var today = dateFormat(this.todayDate, 'isoDate')
      saveAs(blob, 'forecast_canada_' + today + '.tsv')
    },
    getDates () {
      var data = {api: 'get-products-for-forecast'}
      this.$http.post(this.server + '/myapp/find-api-dates/', data).then(resp => {
        var dateOptions = [{label: 'Now', value: null}]
        for (var date of resp.body) {
          dateOptions.push({label: date, value: date})
        }
        this.dateOptions = dateOptions
      }, err => {
        this.error = err.body
      })
    },
    getScreenshot (date) {
      var data = {api: 'get-products-for-forecast', date: date}
      this.$http.post(this.server + '/myapp/find-screenshot/', data).then(resp => {
        this.getProductsFromResp(resp)
      }, err => {
        this.error = err.body
      })
    },
    getVendors () {
      this.$http.get(this.server + '/myapp/get-all-vendors/').then(resp => {
        this.createPurchaseOrderModal.vendors = resp.body
      }, err => {
        this.error = err.body
      })
    },
    openCreatePurchaseOrderModal (location, days) {
      if (!this.poCounts[location + days]) {
        return
      }
      this.createPurchaseOrderModal.opened = true
      this.createPurchaseOrderModal.location = location
      this.createPurchaseOrderModal.days = days / 45 * this.periodSize
      var dateIndex = days == 45 ? 0 : 1
      this.createPurchaseOrderModal.requestDate = this.shipHeaders[dateIndex].date
      var items = []
      for (var s of this.selection) {
        if (this.colEnabled[location + days] && s.selected && s.enabled && s['ship' + days][location]) {
          var item = {...s, quantity: s['ship' + days][location]}
          items.push(item)
        }
      }
      this.createPurchaseOrderModal.items = items
    },
    closeCreatePurchaseOrderModal (poNum) {
      this.createPurchaseOrderModal.opened = false
      if (poNum) {
        this.newPONums.push(poNum)
      }
    },
    forecastDisabledChanged (productId) {
      var message = {productId: productId, canadaForecastDisabled: this.forecastDisabled[productId]}
      this.$http.post(this.server + '/myapp/update-product-forecast-disabled/', message)
    },
  },
  mounted () {
    this.getProducts()
    this.getDates()
    this.getVendors()
  },
}
</script>

<style scoped>
.my-overflow {
  overflow-x: scroll;
}

.table-container {
  max-height: calc(100vh - 80px);
  overflow: auto;

  table {
    text-align: left;
    position: relative;
  }

  th {
    background: white;
    position: sticky;
    top: 0;
  }
}

.my-title {
  display: inline;
}

.po-input {
  width: 70px;
}

.disabled-po-input {
  text-decoration: line-through;
}
</style>
    